import React, { Fragment } from 'react';
import {
  BulkDeleteButton,
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  EditButton,
  List,
  ListButton,
  maxLength,
  minLength,
  RefreshButton,
  required,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  usePermissions,
} from 'react-admin'
import { makeStyles } from '@mui/styles';
import EnableButton from '../Button/EnableButton';
import DisableButton from '../Button/DisableButton';

const createDefaultValues = {
  enabled: false,
};

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const validateChannelName = [required(), minLength(3), maxLength(64)];
const validateChannelCode = [required(), minLength(3), maxLength(32)];

const PostEditActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
    <RefreshButton />
  </TopToolbar>
);

const CustomToolbar = props => (
  <Toolbar {...props} classes={useStyles()}>
    <SaveButton />
  </Toolbar>
);

const CodeBulkActionButtons = props => (
  <Fragment>
    <EnableButton label="Enable" {...props} />
    <DisableButton label="Disable" {...props} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

export const CustomDeleteButton = props => (
  <DeleteButton {...props} mutationMode="pessimistic" />
);

export const ChannelList = props => {
  const { permissions } = usePermissions();
  return (
    <List {...props} bulkActionButtons={<CodeBulkActionButtons />}>
      <Datagrid rowClick="edit">
        <TextField label="Channel ID" source="id" />
        <TextField label="Code" source="code" />
        <TextField label="Name" source="name" />
        <DateField label="Date Created" source="dateCreated" showTime />
        <DateField label="Date Modified" source="dateModified" showTime />
        <BooleanField label="Enabled" source="enabled" />
        {permissions === "ADMIN" && <EditButton />}
      </Datagrid>
    </List>
  );
};

export const ChannelEdit = props => (
  <Edit actions={<PostEditActions />} {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextInput
        label="Channel Name"
        source="name"
        validate={validateChannelName}
      />
      <BooleanInput label="Enabled" source="enabled" />
    </SimpleForm>
  </Edit>
);

export const ChannelCreate = props => (
  <Create actions={<PostEditActions />} {...props}>
    <SimpleForm initialValues={createDefaultValues} redirect="list">
      <TextInput
        label="Channel Name"
        source="name"
        validate={validateChannelName}
      />
      <TextInput label="Channel Code"
        source="code"
        validate={validateChannelCode} />
      <BooleanInput label="Enabled" source="enabled" />
    </SimpleForm>
  </Create>
);